import React, { useEffect, useState } from 'react';
import GeneralHeader from 'components/common/GeneralHeader';
import { Tabs } from 'antd';
import { Configuration } from 'components/user_default_setting';
import useMember from 'hooks/useMember';
import useNotice from 'hooks/useNotice';
import useAuth from 'hooks/useAuth';
import { useQueryClient } from 'react-query';
import { Loading } from 'components';

const UserDefaultSetting = () => {
  const { createDepartment, createService } = useMember();
  const { error, successNotification } = useNotice();
  const queryClient = useQueryClient();
  const { user } = useAuth();
  const [state, setState] = useState({
    departmentData: {},
    serviceData: {},
    statusDepartment: false,
    statusService: false,
  });
  const [loading, setLoading] = useState(false);
  const [pageTitle, setPageTitle] = useState('');
  const { getCustomizeDesign } = useMember();
  const setDepartment = (status: boolean) => {
    setState((pre) => ({
      ...pre,
      departmentData: status === false ? {} : departmentData,
      statusDepartment: status,
    }));
  };

  const setService = (status: boolean) => {
    setState((pre) => ({
      ...pre,
      serviceData: status === false ? {} : serviceData,
      statusService: status,
    }));
  };

  const { departmentData, serviceData, statusDepartment, statusService } =
    state;

  const addDepartment = (data: any) => {
    setState((pre) => ({
      ...pre,
      departmentData: Object.assign(departmentData, data),
    }));
  };

  const addService = (data: any) => {
    setState((pre) => ({
      ...pre,
      serviceData: Object.assign(serviceData, data),
    }));
  };
  useEffect(() => {
    setLoading(true);
    getCustomizeDesign().then((res) => {
      if (res) {
        setPageTitle(res?.company_name);
        setLoading(false);
      }
    });
  }, []);

  const onSave = () => {
    let check = false;
    let errorCheck = 0;
    setLoading(true);
    if (Object.keys(departmentData).length > 0) {
      // createDepartment({departmentData})
      createDepartment(Object.assign({ manager_id: user?.id }, departmentData))
        .then((res) => {
          if (res.status === 201 && check === false) {
            successNotification('Created successfully.');
            check = true;
          }
          setLoading(false);
          queryClient.refetchQueries({
            queryKey: 'get-department-list',
            exact: true,
          });
          setDepartment(false);
          setState((pre) => ({
            ...pre,
            departmentData: {},
          }));
        })
        .catch((err) => {
          error(
            'Missing or incorrect information',
            'Field "Department" is mandatory',
          );
          setLoading(false);
        });
    }

    if (Object.keys(serviceData).length > 2) {
      createService(serviceData)
        .then((res) => {
          if (res.status === 201 && check === false) {
            successNotification('Created successfully.');
            check = true;
          }
          setLoading(false);
          queryClient.refetchQueries({
            queryKey: 'get-list-services',
            exact: true,
          });
          setService(false);
          setState((pre) => ({
            ...pre,
            serviceData: {},
          }));
        })
        .catch((err) => {
          error(
            'Missing or incorrect information',
            'Field "Services" is mandatory',
          );
          setLoading(false);
          // if (errorCheck === 1) {
          //   errorCheck = 3;
          // } else {
          //   errorCheck = 2
          // }
        });
    }
    // if (errorCheck === 1) {
    //   error('Missing or incorrect information', 'Field "Department" is mandatory');
    // } else if (errorCheck === 2) {
    //   error('Missing or incorrect information', 'Field "Services" is mandatory');
    // } else if (errorCheck === 3) {
    //   error('Missing or incorrect information', 'Field "Department" is mandatory\nField "Services" is mandatory');
    // }
  };

  if (loading) return <Loading />;

  return (
    <div>
      <GeneralHeader
        icon={'/icons/defalut_setting_ic.svg'}
        pageTitle={pageTitle}
        btnComponent={
          <button
            style={{
              float: 'right',
              height: 40,
              width: 40,
              padding: 0,
              cursor:
                Object.keys(departmentData).length <= 0 &&
                Object.keys(serviceData).length <= 2
                  ? 'not-allowed'
                  : 'pointer',
            }}
            className={'add_user_button'}
            disabled={
              Object.keys(departmentData).length <= 0 &&
              Object.keys(serviceData).length <= 2
            }
            onClick={() => {
              onSave();
            }}
          >
            <img src="/icons/save.svg" alt="button" />
          </button>
        }
        child={
          <div style={{ marginTop: '50px' }}>
            <Configuration
              createDepartment={statusDepartment}
              createService={statusService}
              setDepartment={setDepartment}
              setService={setService}
              addDepartment={addDepartment}
              addService={addService}
            />
          </div>
        }
      />
    </div>
  );
};

export default UserDefaultSetting;
